/**
 * Practice management tab definitions and role types (must match API Role.roleType values).
 */
export const PRACTICE_TAB_PERMISSIONS = {
  ManageUsers: 'ManageUsers',
  ManageEvalTypes: 'ManageEvalTypes',
  ManageReferenceReports: 'ManageEvalTypes',
  ManagePersonas: 'ManagePersonas',
  ManageFormatTypes: 'ManageFormatTypes',
  ManageBehavioralObs: 'ManageBehavioralObs',
  ManageRecommendations: 'ManageRecommend',
  ManageEvalProcedures: 'ManageEvalProc',
  ManageContentLibrary: 'ManageContentLib',
  ManageTables: 'ManageTables',
  ManageQuestions: 'ManageQuestions',
} as const;

export interface PracticeTab {
  route: string;
  label: string;
  /** Omit for tabs that are always visible (e.g. Settings). */
  permission?: (typeof PRACTICE_TAB_PERMISSIONS)[keyof typeof PRACTICE_TAB_PERMISSIONS];
  /** When true, tab is only shown to global Admin or Practice Admin (not tab-role users). */
  adminOrPracticeAdminOnly?: boolean;
}

export const PRACTICE_TABS: PracticeTab[] = [
  { route: 'users', label: 'Users', permission: PRACTICE_TAB_PERMISSIONS.ManageUsers },
  {
    route: 'evaluation-types',
    label: 'Evaluation Templates',
    permission: PRACTICE_TAB_PERMISSIONS.ManageEvalTypes,
  },
  {
    route: 'reference-reports',
    label: 'Reference Reports',
    permission: PRACTICE_TAB_PERMISSIONS.ManageReferenceReports,
  },
  { route: 'personas', label: 'Personas', permission: PRACTICE_TAB_PERMISSIONS.ManagePersonas },
  {
    route: 'format-types',
    label: 'Format Types',
    permission: PRACTICE_TAB_PERMISSIONS.ManageFormatTypes,
  },
  {
    route: 'behavioral-observations',
    label: 'Behavioral Observations',
    permission: PRACTICE_TAB_PERMISSIONS.ManageBehavioralObs,
  },
  {
    route: 'recommendations',
    label: 'Recommendations',
    permission: PRACTICE_TAB_PERMISSIONS.ManageRecommendations,
  },
  {
    route: 'evaluation-procedures',
    label: 'Evaluation Procedures',
    permission: PRACTICE_TAB_PERMISSIONS.ManageEvalProcedures,
  },
  {
    route: 'content-library',
    label: 'Content Library',
    permission: PRACTICE_TAB_PERMISSIONS.ManageContentLibrary,
  },
  { route: 'tables', label: 'Tables', permission: PRACTICE_TAB_PERMISSIONS.ManageTables },
  {
    route: 'questions',
    label: 'Questions',
    permission: PRACTICE_TAB_PERMISSIONS.ManageQuestions,
  },
  { route: 'signature', label: 'Signature' },
  { route: 'system', label: 'System', adminOrPracticeAdminOnly: true },
];

/** Practice tabs used in user create/edit role toggles (excludes admin-only areas). */
export const PRACTICE_TABS_FOR_ROLE_ASSIGNMENT = PRACTICE_TABS.filter(
  (t) => !t.adminOrPracticeAdminOnly
);
